import { render, staticRenderFns } from "./review-grid-05.vue?vue&type=template&id=10b619f0&scoped=true&"
import script from "./review-grid-05.vue?vue&type=script&lang=js&"
export * from "./review-grid-05.vue?vue&type=script&lang=js&"
import style0 from "./review-grid-05.vue?vue&type=style&index=0&id=10b619f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b619f0",
  null
  
)

export default component.exports